import React, { Component } from 'react';
import CardFlex from '../../components/blog-cards/CardFlex';
import { api_url, headers } from '../../common/config';
import ArticleCard from './ArticleCard';
import { withTranslation } from 'react-i18next';

class Articles extends Component {
    state = {
        isClicked: false,
        articles: [],
    };

    handleClick = () => {
        this.setState({
            isClicked: true,
        });
    };

    componentDidMount = async () => {
        await fetch(
            `${api_url}/autism/items/articles?filter[status]=published`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    articles: res.data,
                });
            });
    };

    render() {
        let cards = null;
        if (this.props.articles.length === 0) {
            return <></>;
        } else {
            cards = this.props.articles.map((article) => {
                return (
                    <ArticleCard
                        id={article.id}
                        title={article.title}
                        name={article.author_name}
                        subtitle={article.sub_title}
                        image={article.image}
                    />
                );
            });
        }
        const { t } = this.props;
        return (
            <div className='articles_container '>
                {this.props.showAll ? (
                    // <CardGrid  arrow={arrow} cards={cards}/>
                    <CardFlex cards={cards} />
                ) : (
                    <>
                        <hr />
                        <div className='title_wrapper'>
                            <h2 className='title'>{t('blog.tabs.articles')}</h2>
                            <button onClick={this.props.showAllBtn}>
                                {t('blog.showAll')}
                            </button>
                        </div>
                        {/* <CardSlider arrow={arrow} cards={cards} /> */}
                        <CardFlex
                            cards={cards}
                            className={'show_first_three_ele'}
                        />
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation()(Articles);
